import { Axios } from "./request";

const API_URL = "branchesapi/v1/cv/";

export const CV_INFORMATION_API = {
  GetBranchCVInformation: (branchId) => {
    return Axios.get(`${API_URL}GetBranchCVInformation?branchId=${branchId}`, {
      transformResponse: (data) => {
        const temp = JSON.parse(data);
        if (temp.success) {
          temp.data.contentBody = JSON.parse(temp.data.contentBody);
        }
        return temp;
      },
    });
  },
};
